<div class="modal-header" style="cursor: move;">
    <h5 class="modal-title" id="modalSearchClientLabel"><i class="lar la-credit-card icon-lg"></i> Card Pay</h5>
    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
        <i aria-hidden="true" class="ki ki-close"></i>
    </button>
</div>
<div class="modal-body payment-body ">

    <h3 class="payment-title" (click)="onCardTap()">Payment Information</h3>

    <div class="payment-tabs mb-4 mt-4">
        <button class="payment-tab active">
            CREDIT / DEBIT
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" class="ms-2">
                <path d="M5 13L9 17L19 7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
            </svg>
        </button>
        <button class="payment-tab">
            BANK ACCOUNT
        </button>
    </div>

    <!-- <div class="row">
        <div class="col-md-12">
            <div class="form-group custom-form-group">
                <label for="cardType">Transaction Type *</label>
                <select class="form-control custom-input" id="cardType" [(ngModel)]="cardType">
                    <option value="">Authorize & Capture</option>
                    <option value="Visa">Visa</option>
                    <option value="MasterCard">MasterCard</option>
                    <option value="American Express">American Express</option>
                    <option value="Discover">Discover</option>
                </select>
            </div>
        </div>
    </div> -->
    <div class="row">
        <div class="col-md-12">
            <div class="form-group custom-form-group">
                <label for="cardNumber">Card Number *</label>
                <input type="text" class="form-control custom-input" id="cardNumber" [(ngModel)]="cardNumber">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-6">
            <div class="form-group custom-form-group">
                <label for="expiryDate">Expires (MM/YY) *</label>
                <input type="text" class="form-control custom-input" id="expiryDate" [(ngModel)]="expiryDate">
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group custom-form-group">
                <label for="cvv">CVV *</label>
                <input #cvvNumber type="text" style="-webkit-text-security: disc;" class="form-control custom-input"
                    id="cvv" [(ngModel)]="cvv">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group custom-form-group">
                <label for="cardHolderName">Card Holder Name *</label>
                <input type="text" class="form-control custom-input" id="cardHolderName" [(ngModel)]="cardHolderName">
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group custom-form-group">
                <label for="amount">Amount *</label>
                <input type="text" class="form-control custom-input" id="amount" [(ngModel)]="amount">
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
    <button type="button" class="btn btn-primary" (click)="onCardPay()"><i class="lar la-check-circle"></i>
        Confirm</button>
</div>